// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/schedule/v1/schedule.proto (package fingertip.creator.schedule.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { CreateEventTypeScheduleMappingRequest, CreateEventTypeScheduleMappingResponse, CreateScheduleRequest, CreateScheduleResponse, DeleteEventTypeScheduleMappingRequest, DeleteEventTypeScheduleMappingResponse, DeleteScheduleRequest, DeleteScheduleResponse, GetEventTypeScheduleMappingsRequest, GetEventTypeScheduleMappingsResponse, GetEventTypesScheduledMembersPublicRequest, GetEventTypesScheduledMembersPublicResponse, GetScheduleRequest, GetScheduleResponse, GetSchedulesRequest, GetSchedulesResponse, UpdateScheduleRequest, UpdateScheduleResponse } from "./schedule_pb.js";

/**
 * @generated from rpc fingertip.creator.schedule.v1.ScheduleService.GetSchedules
 */
export const getSchedules = {
  localName: "getSchedules",
  name: "GetSchedules",
  kind: MethodKind.Unary,
  I: GetSchedulesRequest,
  O: GetSchedulesResponse,
  service: {
    typeName: "fingertip.creator.schedule.v1.ScheduleService"
  }
};

/**
 * @generated from rpc fingertip.creator.schedule.v1.ScheduleService.GetSchedule
 */
export const getSchedule = {
  localName: "getSchedule",
  name: "GetSchedule",
  kind: MethodKind.Unary,
  I: GetScheduleRequest,
  O: GetScheduleResponse,
  service: {
    typeName: "fingertip.creator.schedule.v1.ScheduleService"
  }
};

/**
 * @generated from rpc fingertip.creator.schedule.v1.ScheduleService.CreateSchedule
 */
export const createSchedule = {
  localName: "createSchedule",
  name: "CreateSchedule",
  kind: MethodKind.Unary,
  I: CreateScheduleRequest,
  O: CreateScheduleResponse,
  service: {
    typeName: "fingertip.creator.schedule.v1.ScheduleService"
  }
};

/**
 * @generated from rpc fingertip.creator.schedule.v1.ScheduleService.UpdateSchedule
 */
export const updateSchedule = {
  localName: "updateSchedule",
  name: "UpdateSchedule",
  kind: MethodKind.Unary,
  I: UpdateScheduleRequest,
  O: UpdateScheduleResponse,
  service: {
    typeName: "fingertip.creator.schedule.v1.ScheduleService"
  }
};

/**
 * @generated from rpc fingertip.creator.schedule.v1.ScheduleService.DeleteSchedule
 */
export const deleteSchedule = {
  localName: "deleteSchedule",
  name: "DeleteSchedule",
  kind: MethodKind.Unary,
  I: DeleteScheduleRequest,
  O: DeleteScheduleResponse,
  service: {
    typeName: "fingertip.creator.schedule.v1.ScheduleService"
  }
};

/**
 * @generated from rpc fingertip.creator.schedule.v1.ScheduleService.GetEventTypeScheduleMappings
 */
export const getEventTypeScheduleMappings = {
  localName: "getEventTypeScheduleMappings",
  name: "GetEventTypeScheduleMappings",
  kind: MethodKind.Unary,
  I: GetEventTypeScheduleMappingsRequest,
  O: GetEventTypeScheduleMappingsResponse,
  service: {
    typeName: "fingertip.creator.schedule.v1.ScheduleService"
  }
};

/**
 * @generated from rpc fingertip.creator.schedule.v1.ScheduleService.CreateEventTypeScheduleMapping
 */
export const createEventTypeScheduleMapping = {
  localName: "createEventTypeScheduleMapping",
  name: "CreateEventTypeScheduleMapping",
  kind: MethodKind.Unary,
  I: CreateEventTypeScheduleMappingRequest,
  O: CreateEventTypeScheduleMappingResponse,
  service: {
    typeName: "fingertip.creator.schedule.v1.ScheduleService"
  }
};

/**
 * @generated from rpc fingertip.creator.schedule.v1.ScheduleService.DeleteEventTypeScheduleMapping
 */
export const deleteEventTypeScheduleMapping = {
  localName: "deleteEventTypeScheduleMapping",
  name: "DeleteEventTypeScheduleMapping",
  kind: MethodKind.Unary,
  I: DeleteEventTypeScheduleMappingRequest,
  O: DeleteEventTypeScheduleMappingResponse,
  service: {
    typeName: "fingertip.creator.schedule.v1.ScheduleService"
  }
};

/**
 * @generated from rpc fingertip.creator.schedule.v1.ScheduleService.GetEventTypesScheduledMembersPublic
 */
export const getEventTypesScheduledMembersPublic = {
  localName: "getEventTypesScheduledMembersPublic",
  name: "GetEventTypesScheduledMembersPublic",
  kind: MethodKind.Unary,
  I: GetEventTypesScheduledMembersPublicRequest,
  O: GetEventTypesScheduledMembersPublicResponse,
  service: {
    typeName: "fingertip.creator.schedule.v1.ScheduleService"
  }
};
